import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M27.541667,25 L42.291667,25 C49.691667,25 53.691667,29.15 53.691667,35.65 C53.691667,40.65 50.941667,43.95 48.191667,44.85 L53.691667,61 L45.091667,61 L41.291667,46.65 L32.591667,46.65 L32.591667,61 L27.541667,61 L27.541667,25 Z M32.591667,40.65 L42.241667,40.65 C46.791667,40.65 49.691667,38.3 49.691667,35.95 C49.691667,33.05 46.791667,31.8 42.241667,31.8 L32.591667,31.8 L32.591667,40.65 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
